/*
 * @Author: your name
 * @Date: 2019-11-21 18:30:52
 * @LastEditTime: 2024-07-10 14:22:28
 * @LastEditors: mqlpcthree mql_pcthree@163.com
 * @Description: In User Settings Edit
 * @FilePath: /mei_qi_zeroweb_endlyq/src/store/mutations.js
 */
// path: store/mutations.js
import * as types from './mutations-type' // 引入mutations-types
import { getGoodDict } from '@/api/goods'
import { Message } from 'element-ui'
import { deduplicate } from '../utility_class/my_kit'

const mutations = {
  // 门店信息
  [types.set_tenant](state, data) {
    console.log('更新门店数据了', data)
    state.tenant = data
    // 切换店铺，将上一家店铺的搜索历史清空
    // if (state.tenant.tenantId !== data.tenantId) {
    //     console.log("不懂吗是的-------");
    //     mutations.clearSearchHistory(state)
    // }
  },
  overall: (state, data) => {
    state.overall = data
  },
  [types.set_listDatas](state, data) {
    state.listDatas = data
  },
  [types.set_permissionlist](state, data) {
    state.permissionlist = data
  },
  [types.set_childIndex](state, index) {
    state.childIndex = index
    localStorage.setItem('childIndex', index)
  },
  [types.set_claerListDatas](state, index) {
    state.listDatas = []
    state.permissionlist = []
    state.navindex = 0
    state.childIndex = 0
    state.isActive_second = 0
    localStorage.setItem('childIndex', 0)
    localStorage.setItem('navindex', 0)
    localStorage.setItem('isActive_second', 0)
  },

  // 全局一级菜单
  [types.set_navindex](state, index) {
    state.navindex = index
    localStorage.setItem('navindex', index)
    // localStorage.setItem("isActive_second", 0);
  },
  // 全局二级菜单
  [types.set_second](state, index) {
    if (!navigator.onLine) {
      return Message.error('无网络连接，请重新连接网络')
    }
    state.isActive_second = index
    localStorage.setItem('isActive_second', index)
  },
  // 商品管理*项目类别请求 商品管理*产品类别请求 会员中心*来源等级请求
  async [types.get_DictOptions](state, obj) {
    await getGoodDict({ dict_type: obj.dict_type, asc: obj.asc }).then(res => {
      state[obj.listname] = res.data
    })
  },

  // 跳转更新全局菜单
  [types.set_globalmenulist](state, index) {
    state.navindex = index
    state.childIndex = index
  },

  // 更新后端服务器时间到项目本地
  [types.set_updateServerTime](state, date) {
    state.serverTime = date
  },
  /**
   * @description: 设置会员搜索历史
   * @param {*} state
   * @param {*} data
   * @return {*}
   */
  // data;是添加的会员    state估计是员工
  addSearchHistory(state, data) {
    let tenantId = localStorage.getItem('tenantId')
    // let history = JSON.parse(localStorage.getItem('searchHistoryListsOne')) || []
    // history.forEach((element, index) => {
    //   if (element == null) {
    //     history.splice(index, 1);
    //   }
    // });
    if (data) {
      // -----------------------------------------------------------------------------------------------
      let id = JSON.parse(localStorage.getItem('userInfo')).userId
      // let dataList = {
      //   id: id,
      //   data: [data],
      // };

      // 后面添加的需求   每个店铺的员工都有自己的历史记录   而且切换店铺之后之前的员工历史记录还是要保存下来
      let dataList = {
        tenantId: tenantId, // 店铺id
        historyList: [
          {
            id: id, // 员工id
            data: [data] // 员工历史记录
          }
        ]
      }
      // 判断本地缓存有没有历史记录
      if (state.searchHistoryList.length != 0) {
        let flag = state.searchHistoryList.some(item => item.tenantId == dataList.tenantId)
        // 判断是否有此店铺 有就进入条件 没有就直接添加
        if (flag) {
          state.searchHistoryList.forEach(item => {
            if (item.tenantId == dataList.tenantId) {
              let flago = false
              item.historyList.forEach(items => {
                if (items.id == dataList.historyList[0].id) {
                  items.data.unshift(dataList.historyList[0].data[0])
                } else {
                  flago = true
                }
              })
              if (flago) {
                item.historyList.push(dataList.historyList[0])
              }
            }
          })
        } else {
          state.searchHistoryList.unshift(dataList)
        }
      } else {
        state.searchHistoryList.unshift(dataList)
      }

      // -----------------------------------------------------------------------------------------------
      // state.searchHistoryList
      state.searchHistoryList.forEach(item => {
        item.historyList = deduplicate(item.historyList, 'id')
        item.historyList.forEach(items => {
          items.data = items.data.splice(0, 6)
          items.data = deduplicate(items.data, 'id')
        })
      })

      // -------------------------
      localStorage.setItem('searchHistoryListsOne', JSON.stringify(state.searchHistoryList))
    }
  },
  /**
   * @description: 清理会员搜索历史数量
   * @param {*} state
   * @param {*} index
   * @return {*}
   */
  deleteSearchHistory(state, index = 5) {
    state.searchHistoryList = state.searchHistoryList.slice(0, index)
    let history = JSON.parse(localStorage.getItem('searchHistoryListsOne'))
    history = history.slice(0, index)
    localStorage.setItem('searchHistoryListsOne', JSON.stringify(history))
  },
  /**
   * @description:  清空搜索历史
   * @param {*} state
   * @return {*}
   */
  clearSearchHistory(state) {
    console.log('调用了-----------------')
    // localStorage.setItem("searchHistoryList", JSON.stringify([]));
    // state.searchHistoryList = [];
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js